import { LinkText } from '@components/LinkText';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IRemessaFatura } from '@model/RemessaFatura';
import { IRemessaFaturaFilter } from '@services/RemessaService';
import React from 'react';

export type RemessaDetalheTableProps = {
    data: IData<IRemessaFatura, IRemessaFaturaFilter>
}

export function RemessaDetalheTable ({ data }: RemessaDetalheTableProps) {
    const formatter = useFormatter();

    return (
        <TableNoResult itemCount={data.itemsCount}>
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Fatura ID</TableHeaderCell>
                    <TableHeaderCell>Cliente</TableHeaderCell>
                    <TableHeaderCell>Empresa</TableHeaderCell>
                    <TableHeaderCell>Valor</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    data.items.map((remessaFatura, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell>{remessaFatura.remessaFaturaId}</TableKeyCell>
                                <TableCell>{remessaFatura.faturaId}</TableCell>
                                <TableCell><LinkText to={`/cliente/${remessaFatura.faturaClienteId}`} text={remessaFatura.faturaClienteNome} /></TableCell>
                                <TableCell>{remessaFatura.faturaEmpresaNome}</TableCell>
                                <TableCell>{formatter.toFloat(remessaFatura.valor)}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableBody>
        </TableNoResult>
    )
}